import { useLayoutEffect, useRef } from 'react';
import './ChatTextInput.css';

// A chat box that keeps line breaks (2026-10-07, Admin Buffy C5). A one-line
// <input> drops every line break of a pasted list, so an admin's pasted
// accommodations list reached Buffy as one long line. This textarea looks like
// the one-line box until the text needs more room, grows to its CSS
// max-height, sends on Enter (Shift+Enter adds a line; never while an input
// method is composing) and otherwise takes the same props as the input.
export default function ChatTextInput({ value, onKeyDown, ...props }) {
  const ref = useRef(null);
  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;
    el.style.height = 'auto';
    // scrollHeight leaves out the borders; CSS max-height caps the growth.
    el.style.height = `${el.scrollHeight + el.offsetHeight - el.clientHeight}px`;
  }, [value]);
  const keyDown = event => {
    onKeyDown?.(event);
    if (event.defaultPrevented || event.key !== 'Enter' || event.shiftKey || event.nativeEvent?.isComposing) return;
    event.preventDefault();
    const form = event.currentTarget.form;
    if (!form) return;
    if (form.requestSubmit) form.requestSubmit();
    else form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
  };
  return <textarea ref={ref} rows={1} value={value} onKeyDown={keyDown} {...props} />;
}

// The line under a chat box when a paste reached its limit (the browser keeps
// only the first maxLength characters), so nothing is cut without a word.
export function chatLimitNote(value, maxLength, more) {
  if (!maxLength || String(value || '').length < maxLength) return null;
  return `Messages can be up to ${maxLength.toLocaleString('en-US')} characters, so the end of this one was cut off.${more ? ` ${more}` : ''}`;
}
